export class myAccountConstants {
    static readonly USER_MGMNT_URL = '/user-mgmt/usermanagment/users/';
}